// Lazily loads the Razorpay Checkout.js script from the CDN.
// Only injected when paymentMethod === 'RAZORPAY'; safe to call in COD mode (no-op).
//
// Usage:
//   const loadRazorpay = useRazorpay();
//   const rzp = await loadRazorpay();   // resolves with window.Razorpay or null

const RAZORPAY_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';

let scriptPromise = null;

function loadRazorpayScript() {
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve) => {
    // Already loaded by a previous call
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }

    const existing = document.querySelector(`script[src="${RAZORPAY_SCRIPT}"]`);
    if (existing) {
      // Script tag exists but window.Razorpay not yet ready — wait for load
      existing.addEventListener('load', () => resolve(window.Razorpay || null));
      existing.addEventListener('error', () => { scriptPromise = null; resolve(null); });
      return;
    }

    const script = document.createElement('script');
    script.src = RAZORPAY_SCRIPT;
    script.async = true;
    script.onload = () => resolve(window.Razorpay || null);
    script.onerror = () => {
      scriptPromise = null; // allow retry next time
      resolve(null);
    };
    document.body.appendChild(script);
  });

  return scriptPromise;
}

// Returns a stable function that, when called, loads the script and resolves
// with window.Razorpay (or null on failure). Safe to call multiple times.
export function useRazorpay() {
  return loadRazorpayScript;
}
